var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "codicon:play copy") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "2.-Scheduling-/new-shift/Scheduling",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "The-awesome-new-shift--Scheduling-popup",
  transform: "translate(-335.000000, -228.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "codicon:play-copy",
  transform: "translate(335.000000, 228.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "ViewBox",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.0527864,2.2763932 L1.0527864,14.2763932 C0.886561131,14.6088437 1.12830899,15 1.5,15 L13.5,15 C13.871691,15 14.1134389,14.6088437 13.9472136,14.2763932 L7.9472136,2.2763932 C7.76295146,1.90786893 7.23704854,1.90786893 7.0527864,2.2763932 Z M7.5,3.618 L12.69,13.999 L2.309,13.999 L7.5,3.618 Z",
  id: "Triangle",
  fill: "#252525",
  fillRule: "nonzero",
  transform: "translate(7.500000, 8.500000) rotate(-270.000000) translate(-7.500000, -8.500000) "
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;